import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CANVAS_DASHBOARD, SCHOOL_DASHBOARD, STUDENT_HOME } from '@app/shared/constant/routes';
import { Constants } from 'src/app/shared/constant/constants';
import { SessionManagerService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  constructor(
    private readonly ngZone: NgZone,
    private readonly router: Router,
    private sessionManagerService: SessionManagerService,
  ) {}

  //Navigation based on user roles
  navigationBasedOnUser(data: any) {
    let queryParams: { [key: string]: string };
    let url: string[];
    switch (data.role) {
      case Constants.ROLE_IDS.USER: {
        const ifRedirectionURL = localStorage.getItem('redirectionURL');
        if (ifRedirectionURL) {
          this.router.navigateByUrl(ifRedirectionURL);
          break;
        }

        // opening lastOpened Google Drive File
        if (data.lastOpenedFileInfo != null && Object.prototype.hasOwnProperty.call(data.lastOpenedFileInfo, 'googleDriveFileId')) {
          const levelNo = data.lastOpenedFileInfo.levelNo ? data.lastOpenedFileInfo.levelNo : 1;
          url = [`${CANVAS_DASHBOARD.URL}/${levelNo}`];
        } else if (
          data.levelId &&
          data.lastOpenedFileInfo != null &&
          !Object.prototype.hasOwnProperty.call(data.lastOpenedFileInfo, 'googleDriveFileId')
        ) {
          const levelNo = data.lastOpenedFileInfo.levelNo ? data.lastOpenedFileInfo.levelNo : 1;
          url = [`${CANVAS_DASHBOARD.URL}/${levelNo}`];
          if (data.lastOpenedFileInfo) {
            // if(data.lastOpenedFileInfo.levelId === data.levelId) {
            queryParams = {
              fileId: data.lastOpenedFileInfo.firebaseFileId,
              bfileId: data.lastOpenedFileInfo.id,
            };

            // }
          }
        } else {
          const levelNo = data.levelNo ? data.levelNo : 1;
          if (data.levelNo) {
            url = [`${CANVAS_DASHBOARD.URL}/${levelNo}`];
          } else {
            url = [STUDENT_HOME.URL];
          }
        }
        this.ngZone.run(() => {
          this.router.navigate(url);
          // this.router.navigate(url, { queryParams });
        });
        break;
      }
      case Constants.ROLE_IDS.SCHOOL:
        url = [SCHOOL_DASHBOARD.URL];
        this.ngZone.run(() => {
          this.router.navigate(url, { queryParams });
        });
        break;
      case Constants.ROLE_IDS.ADMIN:
        break;
      default:
    }
  }
}
